import {createPortal} from 'react-dom';
import {PortalProps} from './types';

export function Portal({children}: PortalProps) {
	return createPortal(children, document.body);
}
